import React from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import { db, getApiKey } from './services/firebase'
import { refreshTokens, logoff } from './ducks/Auth'
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom'

import Login from './views/Login/Login'
import Enele from './containers/Enele'
import Partner from './containers/Partner'
import Policy from './views/Policy/Policy'

class App extends React.Component {

    componentDidMount() {
        const { user } = this.props
        user && this._refreshToken(user)
        user && this._watchForDisabledAccounts(user.id)
    }

    render() {
        return (
            <HashRouter>
                {this._handleRouteGroup(this.props.user)}
            </HashRouter>
        )
    }

    _handleRouteGroup = user => {
        if (!user) {
            return (
                <Switch>
                    <Route path="/login" component={Login} key="login_page" />
                    <Route path="/enele-policy" component={Policy} key="enele_policy" />
                    <Route render={() => <Redirect to="/login" />} />
                </Switch>
            )
        } else {
            if (user.roleName.toLowerCase() === 'enele') {
                return <Switch><Enele /></Switch>
            } else {
                return <Switch><Partner /></Switch>
            }

        }
    }


    /**************** 
        Auth REST API - Refresh token
    *****************/
    _refreshToken = user => (
        axios.post(`https://securetoken.googleapis.com/v1/token?key=${getApiKey()}`, {
            grant_type: 'refresh_token',
            refresh_token: user.refreshToken
        })
            .then(response => this.props.refreshTokens({
                accessToken: response.data.access_token,
                refreshToken: response.data.refresh_token
            }))
            .catch(e => this.props.logoff())
    )

    /**************** 
        Log out disabled accounts
    *****************/
    _watchForDisabledAccounts = userID => (
        db.collection('users').doc(userID).onSnapshot(userObserver => (
             userObserver.data() && !userObserver.data().active && this.props.logoff()
        ))
    )
}

const mapStateToProps = state => ({ user: state.auth.user })

export default connect(mapStateToProps, { refreshTokens, logoff })(App)



// WEBPACK FOOTER //
// ./src/App.jsx